export default "__VITE_ASSET__edefd90e__"